import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageContainerComponent } from './home-page-container.component';
import { ProductsModule } from '../products/products.module';
import { QuoteStepModule } from '../quote-step/quote-step.module';
import { CsbQuestionModule } from '../../../csb-quote/csb-question/csb-question.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { SquarespaceModelComponent } from '../../../components/squarespace-model/squarespace-model.component';
import { SquarespaceModelModule } from '../../../components/squarespace-model/squarespace-model.module';
import { HomeBannerModule } from '../home-banner/home-banner.module';
import { ProductsOfferedModule } from '../products-offered/products-offered.module';

@NgModule({
    imports: [
        CommonModule,
        ProductsModule,
        QuoteStepModule,
        CsbQuestionModule,
        MatExpansionModule,
        SquarespaceModelModule,
        HomeBannerModule,
        ProductsOfferedModule,
    ],
    declarations: [HomePageContainerComponent],
    exports: [HomePageContainerComponent],
})
export class HomePageContainerModule {}
